import fossil1Img1 from '@/assets/img/content5/category1/fossilImg1.png'

import fossil2Img1 from '@/assets/img/content5/category2/fossil2Img1.jpg'
import fossil3Img1 from '@/assets/img/content5/category3/fossil3Img1.jpg'
import fossil3Img2 from '@/assets/img/content5/category3/fossil3Img2.jpg'



import fossilImg1 from '@/assets/img/content5/category1/fossilImg1.jpg'
import fossilImg2 from '@/assets/img/content5/category1/fossilImg2.jpg'
import fossilImg3 from '@/assets/img/content5/category1/fossilImg3.jpg'

export const btnList = [
  {
    id: 1,
    cnTitle: '恐龙和早期鸟类羽毛的类型',
    enTitle: 'Different feather types of dinosaurs and early birds',
  },
  {
    id: 2,
    cnTitle: '赫氏近鸟龙',
    enTitle: '<em>Anchiornis huxleyi</em> Xu et al., 2009',
  },
  {
    id: 3,
    cnTitle: '小盗龙',
    enTitle: '<em>Microraptor</em>',
  },
]

export const featheredList = [ // 爬行动物展示化石
  {
    id: 1,
    src: fossilImg1,
    title: '近鸟龙',
    enTitle: '<em>Anchiornis huxleyi</em> Xu et al., 2009',
    details: '<p>近鸟龙是小型具羽毛恐龙，属于手盗龙类伤齿龙科，产于我国内蒙古中晚侏罗世玲珑塔生物群。其前后肢上都分布着奇特的飞羽，专家推测其羽毛的颜色可能相当华丽，而且可能具有滑翔能力。</p><p>赫氏近鸟龙是第一个被精确鉴定出羽毛颜色的恐龙。这种恐龙整体呈现灰、黑色，具有红棕色的羽冠，头顶羽毛基部呈黑色，面部羽毛主要为黑色，散布着红褐色羽毛，前后肢长羽毛为黑白相间，以条纹方式排列，后肢为灰色羽毛，脚掌、脚趾为黑色羽毛，还有黑光发亮的醒目翼尖。</p>',
  },
  {
    id: 2,
    src: fossilImg2,
    title: '小盗龙',
    enTitle: '<em>Microraptor</em>',
    details: '小盗龙的拉丁名意思是“小型盗贼”，是生活在我国东北地区早白垩世时期的小型驰龙科恐龙。身长不到1米，身披羽毛。它们除身体覆盖一层厚羽毛外，尾巴末端还有钻石状羽毛扇，头部具有高耸的羽毛冠饰，类似于某些现代鸟类，比如北美的黑啄木鸟。小盗龙可能像鸟一样栖息在树上，也可能喜欢在树林里滑翔并捕食湖泊中的鱼类。',
  },
  {
    id: 3,
    src: fossilImg3,
    title: '单垂鹤鸵',
    enTitle: '<em>Casuarius unappendiculatus</em> (Blyth, 1860)',
    details: '',
  },
]

export const featheredDinosaurs = {
  animalType: '具羽毛恐龙', // 动物类别
  animalTypeEn: 'Feathered Dinosaurs', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '<p>恐龙和早期鸟类羽毛的类型 Different feather types of dinosaurs and early birds</p><p>鸟类身上结构精巧的羽毛是通过其恐龙祖先一代代遗传和选择而获得的，羽毛的功能也从最初的保暖和炫耀演变成为飞行提供升力。</p><p>恐龙腿上的羽毛最早可能是用来御寒，后来变成真正的飞羽，用于辅助飞行，并一直在早期鸟类中保留，直到鸟类演化的某一阶段，脚上的羽毛才退化，变成了鳞片。</p>', // 动物文字介绍
  showList: featheredList,
}

export const differentList = [
  {
    id: 1,
    src: fossil1Img1,
    style: 'background: #fff;',
    title: '',
    enTitle: '',
    details: '<p>鸟类身上结构精巧的羽毛是通过其恐龙祖先一代代遗传和选择而获得的，羽毛的功能也从最初的保暖和炫耀演变成为飞行提供升力。</p><p>恐龙腿上的羽毛最早可能是用来御寒，后来变成真正的飞羽，用于辅助飞行，并一直在早期鸟类中保留，直到鸟类演化的某一阶段，脚上的羽毛才退化，变成了鳞片。</p>',
  },
]

export const differentAnimal = {
  animalType: '恐龙和早期鸟类羽毛的类型', // 动物类别
  animalTypeEn: 'Different feather types of dinosaurs and early birds', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '<p>鸟类身上结构精巧的羽毛是通过其恐龙祖先一代代遗传和选择而获得的，羽毛的功能也从最初的保暖和炫耀演变成为飞行提供升力。</p><p>恐龙腿上的羽毛最早可能是用来御寒，后来变成真正的飞羽，用于辅助飞行，并一直在早期鸟类中保留，直到鸟类演化的某一阶段，脚上的羽毛才退化，变成了鳞片。</p>', // 动物文字介绍
  showList: differentList,
}

export const anchiornisList = [
  {
    id: 1,
    src: fossil2Img1,
    title: '化石：赫氏近鸟龙',
    enTitle: '<em>Anchiornis huxleyi</em> Xu et al., 2009',
    details: '赫氏近鸟龙是第一个被精确鉴定出羽毛颜色的恐龙。这种恐龙整体呈现灰、黑色，具有红棕色的羽冠，头顶羽毛基部呈黑色，面部羽毛主要为黑色，散布着红褐色羽毛，前后肢长羽毛为黑白相间，以条纹方式排列，后肢为灰色羽毛，脚掌、脚趾为黑色羽毛，还有黑光发亮的醒目翼尖。',
  },
]

export const anchiornisAnimal = {
  animalType: '赫氏近鸟龙', // 动物类别
  animalTypeEn: '<em>Anchiornis huxleyi</em> Xu et al., 2009', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '<p>近鸟龙是小型具羽毛恐龙，属于手盗龙类伤齿龙科，产于我国内蒙古中晚侏罗世玲珑塔生物群。其前后肢上都分布着奇特的飞羽，专家推测其羽毛的颜色可能相当华丽，而且可能具有滑翔能力。</p><p>赫氏近鸟龙是第一个被精确鉴定出羽毛颜色的恐龙。这种恐龙整体呈现灰、黑色，具有红棕色的羽冠，头顶羽毛基部呈黑色，面部羽毛主要为黑色，散布着红褐色羽毛，前后肢长羽毛为黑白相间，以条纹方式排列，后肢为灰色羽毛，脚掌、脚趾为黑色羽毛，还有黑光发亮的醒目翼尖。</p>', // 动物文字介绍
  showList: anchiornisList,
}

export const microraptorList = [
  {
    id: 1,
    src: fossil3Img1,
    title: '化石：小盗龙',
    enTitle: '<em>Microraptor</em>',
    details: '小盗龙的拉丁名意思是“小型盗贼”，是一种生活在我国东北地区早白垩世时期的小型驰龙科恐龙。身长不到1米，身披羽毛。它们除身体覆盖一层厚羽毛外，尾巴末端还有钻石状羽毛扇，头部具有高耸的羽毛冠饰，类似于某些现代鸟类，比如北美的黑啄木鸟。小盗龙可能像鸟一样栖息在树上，也可能喜欢在树林里滑翔并捕食湖泊中的鱼类。',
  },
  {
    id: 2,
    src: fossil3Img2,
    title: '现代鸟：单垂鹤鸵',
    enTitle: '<em>Casuarius unappendiculatus</em> (Blyth, 1860)',
    details: '',
  },
]

export const microraptorAnimal = {
  animalType: '小盗龙', // 动物类别
  animalTypeEn: '<em>Microraptor</em>', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '小盗龙的拉丁名意思是“小型盗贼”，是生活在我国东北地区早白垩世时期的小型驰龙科恐龙。身长不到1米，身披羽毛。它们除身体覆盖一层厚羽毛外，尾巴末端还有钻石状羽毛扇，头部具有高耸的羽毛冠饰，类似于某些现代鸟类，比如北美的黑啄木鸟。小盗龙可能像鸟一样栖息在树上，也可能喜欢在树林里滑翔并捕食湖泊中的鱼类。', // 动物文字介绍
  showList: microraptorList,
}